import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import generalForm from './general-form';

const beforeCallDetail = {
	name: 'record',
	path: '/dataset/unified_addresses/detail/:recordId',
};

export const UnifiedAddressConfig: IDatasetConfig = {
	name: 'unified_addresses',
	title: 'Indirizzi',
	singleTitle: 'Indirizzo',
	ajaxDatasetCode: 'unified_addresses',
	fieldsMap: fieldsMap,
	supportProperties: true,
	enabledActions: {
		detail: true,
		create: true,
		edit: true,
		list: true
	},
	formConfigsMap: {
		generalForm
	},
	defaultActions: {
		detail: {
			openType: DatasetActionOpenType.PAGE,
			beforeCalls: [ beforeCallDetail ],
			viewConfig: {
				formConfig: generalForm,
				actions: {
					edit: true,
					delete: false
				}
			}
		},
		create: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				formConfig: generalForm
			}
		},
		edit: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			},
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: true,
				defaultSortBy: 'created_at',
				defaultSortDirection: 'desc',
				columns: [
					{
						title: 'Città',
						key: 'city'
					},
					{
						title: 'Indirizzo',
						key: 'street'
					},
					{
						title: 'Numero',
						key: 'number'
					}
				],
				actions: ['create', 'detail', 'delete']
			}
		}
	}
}
